import { render, staticRenderFns } from "./Pesquisa.vue?vue&type=template&id=41b0143f&scoped=true"
import script from "./Pesquisa.vue?vue&type=script&lang=js"
export * from "./Pesquisa.vue?vue&type=script&lang=js"
import style0 from "./Pesquisa.vue?vue&type=style&index=0&id=41b0143f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b0143f",
  null
  
)

export default component.exports